module.exports = __webpack_public_path__ + "img/p_11.74791ece.jpg";